export default "__VITE_ASSET__CaV8VxwF__"